import React from 'react';

interface TabButtonProps {
  label: string;
  onClick: () => void;
  isActive?: boolean;
}

const TabButton: React.FC<TabButtonProps> = ({
  label,
  onClick,
  isActive = false,
}) => {
  return (
    <button
      onClick={onClick}
      className={`${
        isActive
          ? 'bg-white text-blue-600 border-blue-600 border-b-white z-10 -mb-px'
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      } px-4 sm:px-6 py-2 rounded-t-lg font-medium transition-colors border-t border-l border-r border-b border-gray-300 flex-shrink-0`}
    >
      <div className="max-h-12 line-clamp-2 overflow-hidden text-ellipsis min-w-0">
        {label}
      </div>
    </button>
  );
};

export default TabButton;
